import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconRegularEmail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 11.9998C7.4832 11.9998 6.9672 11.8464 6.5264 11.5356L0 6.9331V13.3595C0 14.1106 0.672 14.7198 1.5 14.7198H14.5C15.3288 14.7198 16 14.1106 16 13.3595V6.93387L9.4752 11.5379C9.0344 11.8471 8.5152 11.9998 8 11.9998ZM0.5088 6.1434L7.1408 10.8222C7.39125 10.9962 7.69212 11.0898 8.0008 11.0898C8.30948 11.0898 8.61035 10.9962 8.8608 10.8222L15.4928 6.1434C15.784 5.91667 16 5.56886 16 5.20023C16 4.44909 15.328 3.83984 14.5 3.83984H1.5C0.6712 3.83907 0 4.44832 0 5.19946C0 5.56809 0.188 5.91667 0.5088 6.14263V6.1434Z",
		fill: "currentColor"
	})
});
export default SvgIconRegularEmail;
